<template>
  <div class="main-body">
    <div style="overflow-y: auto;overflow-x:hidden;background-color: #fff;height: 100vh;width: 100vw">
      <gaode-map v-if="gaoDeShow" :order-id="form.data.orderId"
                 :order="form.order"
                 style="height:98%;margin:5px"></gaode-map>
      <time-line v-if="timeLineShow" :order-id="form.data.orderId"
                 :express-code="form.data.expressCode"
                 :wms-no="form.data.wmsNo"
                 :ifs-no="form.data.ifsNo"
                 :receive-address="form.data.receiveAddress"
                 style="height:98%;margin:5px"></time-line>
    </div>
  </div>
</template>

<script>
import {
  getDataByWmsNo,
} from '@/api/order';
import GaodeMap from '@/components/GaodeMap.vue';
import TimeLine from '@/components/TimeLine.vue';

function handledbClick(row) {
  this.gaoDeShow = false;
  setTimeout(() => {
    if (row.transportType === 'GPS') {
      this.form.order = row;
      this.timeLineShow = false;
      this.gaoDeShow = true;
    } else {
      this.gaoDeShow = false;
      this.timeLineShow = true;
      this.form.data.orderId = row.orderNo;
      this.form.data.expressCode = row.expressCode;
      this.form.data.receiveAddress = row.receiveAddress;
      this.form.data.wmsNo = row.wmsNo;
      this.form.data.ifsNo = row.ifsNo;
    }
  }, 500);
}

export default {
  name: "OrderList",
  components: {
    GaodeMap,
    TimeLine,
  },
  methods: {
    handledbClick,
  },
  async created() {
    this.token = localStorage.getItem("token")?localStorage.getItem("token"):"login_without_password"
    const response = await getDataByWmsNo({
      wmsNo: this.wmsNo,
      ifsNo: this.ifsNo
    });
    if (response.code === 1200 && response.data.order) {
      this.handledbClick(response.data.order);
    }
  },
  watch: {},
  data() {
    return {
      wmsNo: this.$route.query.wmsNo,
      ifsNo: this.$route.query.ifsNo,
      gaoDeShow: false,
      timeLineShow: false,
      token: '',
      form: {
        data: {},
      },
    };
  },
  mounted() {
  }
}
</script>

<style scoped>

</style>
